<ng-container *ngIf="data">
  <div class="breadcrumb-container">
    <mat-icon color="primary" *ngIf="data.icon">{{data.icon}}</mat-icon>
    <ol class="breadcrumb">
      <li
        *ngFor="let item of data.items"
        [ngClass]="{'active': item.active}">
                <a
          *ngIf="!item.active"
          [routerLink]="item.link">
          {{item.label}}</a>
                <span *ngIf="item.active">{{item.label}}</span>
            </li>
    </ol>

  </div>

</ng-container>
